export enum OrderItemStatusEnum {
    Available = 'Available',
    Invalidated = 'Invalidated',
    CancelRequested = 'CancelRequested',
    Cancelled = 'Cancelled',
    BookingConnected = 'BookingConnected',
    Locked = 'Locked',
    Consumed = 'Consumed'
}
